import { FONT_FAMILY_REGULAR } from '@unistocks/shared/consts';
import { color } from '@unistocks/shared/utils/color';
import { getFontSize, getTokens, getTokenValue, isWeb, useTheme } from 'tamagui';

export const X_AXIS_LABEL_ROTATION = 30;

/**
 * Shared axis styles for both native (Victory-Native/Skia) and web (ECharts) charts.
 * Covers axis lines, labels, crosshair/pointer label, and mark-line colours.
 */
export const useAxisStyles = () => {
  const theme = useTheme();
  const {
    radius: { $3: radius3 },
    space: { $2: space2 }
  } = getTokens();
  const fontSize = getFontSize('$1', { font: '$body' });

  return {
    lineColor: color(theme.color6.val).toCSSHex(),
    color: color(theme.bodyFont.val).toCSSHex(),
    headingColor: color(theme.headingFont.val).toCSSHex(),
    background: color(theme.color4.val).toCSSHex(),
    borderColor: color(theme.color6.val).toCSSHex(),
    borderWidth: 1,
    borderRadius: radius3.val,
    padding: space2.val,
    fontSize,
    fontFamily: FONT_FAMILY_REGULAR,
    rotate: X_AXIS_LABEL_ROTATION
  };
};

/**
 * Shared tooltip styles for both native (Victory-Native/Skia) and web (ECharts) charts.
 * Covers the floating tooltip panel and static rich-text labels.
 */
export const useTooltipStyles = () => {
  const theme = useTheme();
  const radius3 = getTokenValue('$3', 'radius');
  const space2 = getTokenValue('$2', 'space');
  const fontSize = getFontSize(isWeb ? '$1' : '$2', { font: '$body' });
  const headingFontSize = getFontSize('$3', { font: '$heading' });

  return {
    background: color(theme.color4.val).toCSSHex(),
    borderColor: color(theme.color6.val).toCSSHex(),
    borderWidth: 2,
    borderRadius: radius3,
    padding: space2,
    color: color(theme.bodyFont.val).toCSSHex(),
    fontSize,
    fontFamily: FONT_FAMILY_REGULAR,
    headingColor: color(theme.headingFont.val).toCSSHex(),
    headingFontSize
  };
};
